import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, ViewEncapsulation } from '@angular/core';
import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
import { ActivatedRoute, Router } from '@angular/router';
import { CoursewareService } from 'src/services/CoursewareService';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { ArticleEntryDisplayModel } from 'src/model/ContentEntry/ArticleEntryDisplayModel';
import { CoursewareQuizQuestionEditModel } from 'src/model/Test/CoursewareQuizQuestionEditModel';
import { Error } from 'src/model/Error';
import { AlertService } from 'src/app/_alert';
import { MetaService } from 'src/services/MetaService';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-courseware-quiz',
    templateUrl: './courseware-quiz.component.html',
    styleUrls: ['./courseware-quiz.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class CoursewareQuizComponent implements OnInit, OnDestroy {
    public contentEntry: ArticleEntryDisplayModel;
    public breadcrumbs: Breadcrumb[] = [];
    public questions: CoursewareQuizQuestionEditModel[] = [];
    public alias = null;

    constructor(@Inject(PLATFORM_ID) private platformId, private _router: Router, private titleService: Title, private canonicalService: MetaService, private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) {
    }

    ngOnInit() {
        this.alias = this.route.snapshot.paramMap.get('alias');
        // TODO - IMPLEMENT CACHING AND/OR ONLY GET NECCESSSARY INFORMATION.  WE SHOULD NOT RETREIVE DATA FROM getCourseEntries BOTH HER AND IN CONTENT VIEW
        this.coursewareService.getCourseEntries(this.alias).subscribe(data => {
            this.contentEntry = data;
            if (this.contentEntry.ID) {
                this.breadcrumbs = [{ Title: "Foundations of Law", URL: "/coursewareview" }, { Title: this.contentEntry.Lineage[0].TopicInformation.Title, URL: "/coursewareview/" + this.contentEntry.Lineage[0].TopicInformation.Alias }, { Title: this.contentEntry.Lineage[1].TopicInformation.Title, URL: "/coursewareview/" + this.contentEntry.Lineage[0].TopicInformation.Alias + "/" + this.contentEntry.Lineage[1].TopicInformation.Alias }, { Title: this.contentEntry.RenderData.ContentEntryDescriptor.Information.Title, URL: "/coursewarecontentview/" + this.contentEntry.RenderData.ContentEntryDescriptor.Information.Alias }];
                this.canonicalService.createCanonicalURL(this._router.url, "/coursewarecontentview/" + this.contentEntry.RenderData.ContentEntryDescriptor.Information.Alias);
                this.titleService.setTitle("Foundations of Law Self Quiz - " + this.contentEntry.RenderData.ContentEntryDescriptor.Information.Title);
                this.canonicalService.addMetaTags(null, this.contentEntry.RenderData.ContentEntryDescriptor.Information.Description, null, this.contentEntry.RenderData.ContentEntryDescriptor.Information.Title, null);

                this.coursewareService.getCourseQuiz(this.contentEntry.ID).subscribe(quizData => {
                    this.questions = quizData;
                    if (!this.questions.length) {
                        this.questions = null;
                        let error: Error = quizData;
                        this.alertService.error(error.Message);
                    }
                });
            } else {
                this.contentEntry = null;
                let error: Error = data;
                this.alertService.error(error.Message);
            }
        });
    }

    ngOnDestroy() {
        this.canonicalService.removeCanonicalURL();
    }

    endTest() {
        this._router.navigate(["/coursewarecontentview", this.alias]);
    }

    public containsData() {
        if (!this.contentEntry)
            return false;
        return true;
    }
}
